import { all, delay, put, call, takeLatest, select } from "redux-saga/effects";
import { getBestPrices } from "services/api";
import {
  bestPriceCoins,
  setCoins,
  setRefresh,
} from "store/reducers/bestPriceCoins";
import {
  DELAY_OF_GEETING_TOKEN,
  DELAY_OF_GEETING_TOKEN_IN_CATCH,
} from "configs/constants";

function* bestPriceCoinsSaga(): any {
  while (true) {
    const state = yield select();
    const { tokenList } = state.bestPriceCoins;
    try {
      const response = yield call(() => getBestPrices());
      if (JSON.stringify(tokenList) === JSON.stringify(response)) {
        yield put({
          payload: false,
          type: setRefresh.type,
        });
      } else {
        yield put({
          payload: true,
          type: setRefresh.type,
        });
      }
      yield put({
        payload: { response },
        type: setCoins.type,
      });
      yield delay(DELAY_OF_GEETING_TOKEN);
    } catch (err) {
      yield delay(DELAY_OF_GEETING_TOKEN_IN_CATCH);
      yield put({
        payload: false,
        type: setCoins.type,
      });
      console.log(err, "err");
    }
  }
}

export default function* root() {
  yield all([takeLatest(bestPriceCoins.type, bestPriceCoinsSaga)]);
}
